<template>
    <NuxtLayout>
        <div class="body-block">
            <div class="title-container">
                <div class="container-xl">
                    <div class="doc-title-container">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h1 class="page_title mt-10">Политика обработки персональных данных ТОО «ПЭК
                                    Казахстан»</h1>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block text-end">
                                <img src="/images/documents/document_view.png" alt="" class="doc-image"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-documents">
                <div class="container-xl">
                    <p>Внимательно изучите нашу политику в отношении обработки персональных данных и сведения о
                        реализуемых требованиях
                        к защите персональных данных, чтобы знать, какие ваши персональные данные и как мы
                        обрабатываем.</p>
                    <p>Под «обработкой персональных данных» понимается любое действие или совокупность действий,
                        совершаемые с
                        персональными данными, включая сбор, систематизацию, хранение, изменение, использование,
                        предоставление,
                        удаление персональных данных.</p><h4 class="">1. Общие положения</h4>
                    <p>1.1. Мы - ТОО «ПЭК Казахстан», зарегистрированное по адресу: г. Алматы, Жетысуский район, ул.
                        Казыбаева, д. 3 БИН
                        121140009856, мультисервисный оператор логистических услуг, эксперт в сфере комплексных решений
                        по организации
                        грузоперевозок на территории Республики Казахстан и за рубежом.&nbsp;</p>
                    <p>1.2. Настоящая политика об обработке персональных данных (далее – «Политика») разработана и
                        применяется ТОО «ПЭК
                        Казахстан» в соответствии с требованиями Закона Республики Казахстан от 21.05.2013 № 94-V «О
                        персональных данных
                        и их защите». Политика определяет порядок и условия Оператора в отношении обработки персональных
                        данных,
                        устанавливает процедуры, направленные на предотвращение и выявление нарушений законодательства
                        Республики
                        Казахстан, а также устранение последствий нарушений, связанных с обработкой персональных данных.
                        Все вопросы,
                        связанные с обработкой персональных данных, не урегулированные настоящей Политикой, разрешаются
                        в соответствии с
                        действующим законодательством Республики Казахстан в области персональных данных.</p>
                    <h4>2. Принципы, условия и цели обработки персональных данных:</h4>
                    <p>2.1. ТОО «ПЭК Казахстан» может осуществлять обработку Ваших персональных данных с использованием
                        средств
                        автоматизации или без использования таких средств.&nbsp;&nbsp;</p>
                    <p>2.2. Обработка персональных данных осуществляются ТОО «ПЭК Казахстан» с Вашего согласия, кроме
                        случаев,
                        предусмотренных Законом Республики Казахстан от 21.05.2013 № 94-V «О персональных данных и их
                        защите». Согласие
                        может быть дано в письменном виде, с использованием электронных средств, либо иными способами,
                        позволяющими ТОО
                        «ПЭК Казахстан» подтвердить получение согласия.</p>
                    <p>2.3. Обработка Ваших персональных данных осуществляется в соответствии со следующими
                        принципами:</p>
                    <ul>
                        <li>обработка персональных данных должна осуществляться на законной и справедливой основе;</li>
                        <li>обработка персональных данных должна ограничиваться достижением конкретных, заранее
                            определенных и законных
                            целей;
                        </li>
                        <li>содержание и объем обрабатываемых персональных данных должны соответствовать заявленным
                            целям обработки;
                        </li>
                        <li>обрабатываемые персональных данных не должны быть избыточными по отношению к заявленным
                            целям их
                            обработки;
                        </li>
                        <li>при обработке персональных данных должны быть обеспечены точность персональных данных, их
                            достаточность, а в
                            необходимых случаях и актуальность по отношению к целям обработки персональных данных. ТОО
                            «ПЭК Казахстан»
                            принимает меры по удалению или уточнению неполных или неточных данных.
                        </li>
                    </ul>
                    <p>2.4. В ТОО «ПЭК Казахстан» проводится регулярный анализ соответствия процессов обработки
                        персональных данных
                        указанным выше принципам. Данный анализ проводится в случае:</p>
                    <ul>
                        <li>создания новых или внесения изменений в существующие процессы обработки персональных
                            данных;
                        </li>
                        <li>создания новых или внесения изменений в существующие информационные системы персональных
                            данных, которые
                            используются для обеспечения безопасности этих данных, а также включают средства их
                            обработки;
                        </li>
                        <li>изменения нормативно-правовых актов, затрагивающих принципы и(или) процессы обработки
                            персональных данных.
                        </li>
                    </ul>
                    <p>2.5.&nbsp; Хранение Ваших персональных данных осуществляется не дольше, чем этого требуют цели
                        обработки
                        персональных данных, и они подлежат уничтожению по достижению целей обработки или в случае
                        утраты необходимости
                        в их достижении, если иное не предусмотрено законодательством Республики Казахстан.</p>
                    <p>2.6. Мы осуществляем хранение Ваших персональных данных в базах данных, расположенных на
                        территории Республики
                        Казахстан.</p>
                    <p>2.7.&nbsp; Условием прекращения обработки персональных данных может являться достижение целей
                        обработки
                        персональных данных, истечение срока действия согласия или отзыв Вами согласия на обработку его
                        персональных
                        данных, а также выявление неправомерной обработки персональных данных.</p>
                    <p>2.8.&nbsp; Когда Вы посещаете наш сайт https://pecom.kz/ (далее – Сайт), мы можем собирать
                        техническую
                        информацию, к которой в том числе относятся: IP-адрес (адрес Интернет-протокола), тип
                        используемого устройства,
                        операционной системы и браузера, уникальный идентификатор Вашего устройства, адрес ссылающихся
                        веб-сайтов, путь,
                        по которому Вы проходите через веб-сайты.&nbsp;</p>
                    <p>2.9.&nbsp; По мере того, как Вы просматриваете Сайт, нами могут собираться определенные данные о
                        Ваших действиях
                        с использованием автоматических технологий сбора данных. Среди таких данных ссылки, на которые
                        Вы нажимаете при
                        посещении Сайта, страницы или контент, которые Вы просматриваете, период просмотра
                        страницы/контента, а также
                        другая аналогичная информация и статистика о посещении страницы, например, время отклика
                        контента, ошибки
                        загрузки и продолжительность посещения некоторых страниц. Данная информация фиксируется с
                        помощью автоматических
                        технологий, таких как файлы cookies (файлы cookies браузера, файлы flash cookies) и веб-маяки, а
                        также
                        собирается с использованием сторонних сервисов отслеживания и веб-аналитики. ТОО «ПЭК Казахстан»
                        использует
                        данную информацию для обеспечения работоспособности Сайта, для повышения качества оказываемых
                        Вам услуг,
                        исправления ошибок, упрощения использования Сайта.</p>
                    <p>2.10.&nbsp; Взаимодействие с центральными и местными органами исполнительной власти по вопросам
                        обработки и
                        защиты персональных данных, которые обрабатываются ТОО «ПЭК Казахстан», осуществляется в рамках
                        законодательства
                        Республики Казахстан.</p><h4 class="">3. На кого распространяется политика</h4>
                    <p>3.1.&nbsp; Настоящая политика распространяется на Вас в случаях, когда Вы взаимодействуете с ТОО
                        «ПЭК Казахстан»
                        в качестве:</p>
                    <ul>
                        <li>работника;</li>
                        <li>бывшего работника;</li>
                        <li>члена семьи работника;</li>
                        <li>лица, претендующего на замещение вакантных должностей в ТОО «ПЭК Казахстан»;</li>
                        <li>лица, проходящего учебную, производственную или преддипломную практику в ТОО «ПЭК
                            Казахстан»;
                        </li>
                        <li>участника маркетинговых и иных мероприятий, направленных на продвижение услуг, сервисов,
                            товаров и
                            продукции, организуемых и (или) проводимых ТОО «ПЭК Казахстан» или по его поручению;
                        </li>
                        <li>пользователя веб-сервисов ТОО «ПЭК Казахстан»;&nbsp;</li>
                        <li>потребителя товаров и услуг;</li>
                        <li>третьего лица.</li>
                    </ul>
                    <p>3.2.&nbsp; Объем персональных данных, которые мы обрабатываем зависит от того к какой категории
                        субъектов
                        персональных данных Вы относитесь. Цели, состав, сроки и способы обработки персональных данных в
                        отношении
                        каждой категории субъектов персональных данных изложены в Приложении №1 к настоящей
                        Политике.</p><h4 class="">4.
                    Передача персональных данных</h4>
                    <p>4.1. ТОО «ПЭК Казахстан» на основании договора может поручить обработку персональных данных
                        третьему лицу.
                        Существенным условием такого договора является наличие права у данного лица на обработку
                        персональных данных,
                        обязанность обеспечения указанным лицом конфиденциальности персональных данных и безопасности
                        персональных
                        данных при их обработке.</p>
                    <p>4.2. В поручении на обработку персональных данных в обязательном порядке определяются:</p>
                    <ul>
                        <li>перечень персональных данных;</li>
                        <li>перечень действий с персональными данными, которые будут совершаться лицом, осуществляющим
                            обработку
                            персональных данных;&nbsp;
                        </li>
                        <li>цели обработки при этом не должны противоречить целям, заявленным Вам в договоре с ТОО «ПЭК
                            Казахстан»,
                            согласии и иных документах;
                        </li>
                        <li>обязанность соблюдать, требования к защите персональных данных, принципы и правила обработки
                            персональных
                            данных, предусмотренные Законом Республики Казахстан от 21.05.2013 № 94-V «О персональных
                            данных и их
                            защите»;
                        </li>
                        <li>обязанность такого лица соблюдать конфиденциальность персональных данных и обеспечивать
                            безопасность
                            персональных данных при их обработке.
                        </li>
                        <li>4.3. ТОО «ПЭК Казахстан» в ходе своей деятельности и оказания Вам услуг может осуществляет
                            трансграничную
                            передачу персональных данных юридическим лицам на территории иностранных государств. При
                            этом вопросы
                            обеспечения адекватной защиты Ваших персональных данных при трансграничной передаче являются
                            приоритетом для
                            ТОО «ПЭК Казахстан».
                        </li>
                    </ul>
                    <p>4.4. Трансграничная передача Ваших персональных данных на территорию иностранных государств, не
                        обеспечивающих
                        адекватной защиты персональных данных, осуществляется только в случаях:</p>
                    <ul>
                        <li>наличия Вашего согласия в письменной форме на трансграничную передачу персональных данных;&nbsp;</li>
                        <li>исполнения договора, стороной которого Вы являетесь и который прямо предусматривает
                            необходимость
                            трансграничной передачи персональных данных;
                        </li>
                        <li>в иных предусмотренных законодательством случаях.</li>
                    </ul>
                    <h4 class="">5. Меры, направленные на обеспечение безопасности персональных данных&nbsp;</h4>
                    <p>5.1. В целях обеспечения адекватной защиты персональных данных ТОО «ПЭК Казахстан»&nbsp; проводит
                        оценку вреда,
                        который может быть причинен Вам в случае нарушения безопасности их персональных данных, а также
                        определяет
                        актуальные угрозы безопасности персональных данных при их обработке в информационных системах
                        персональных
                        данных.</p>
                    <p>5.2.&nbsp; С целью обеспечения безопасности персональных данных при их обработке ТОО «ПЭК
                        Казахстан» принимает
                        необходимые и достаточные правовые, организационные и технические меры для защиты персональных
                        данных от
                        неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования,
                        предоставления,
                        распространения персональных данных, а также от иных неправомерных действий в отношении
                        персональных данных.</p>
                    <p>5.3.&nbsp; ТОО «ПЭК Казахстан» добивается того, чтобы все реализуемые мероприятия по
                        организационной и
                        технической защите персональных данных осуществлялись на законных основаниях, в том числе в
                        соответствии с
                        требованиями законодательства Республики Казахстан по вопросам обработки персональных
                        данных.</p>
                    <p>5.4.&nbsp; Руководство ТОО «ПЭК Казахстан» осознает важность и необходимость обеспечения
                        безопасности Ваших
                        персональных данных и поощряет постоянное совершенствование системы защиты персональных данных,
                        обрабатываемых в
                        рамках выполнения основной деятельности компании.</p>
                    <p>5.5. В ТОО «ПЭК Казахстан» назначено лицо, ответственное за организацию обработки персональных
                        данных.</p>
                    <p>5.6. Каждый новый работник ТОО «ПЭК Казахстан», непосредственно осуществляющий обработку
                        персональных данных,
                        подлежит ознакомлению с настоящей Политикой и другими локально-нормативными актами по вопросам
                        обработки и
                        реализации требований к защите персональных данных и несет ответственность за их соблюдение.</p>
                    <p>5.7.&nbsp; Доступ к данным чётко разграничен между структурными подразделениями, а правомерность
                        их полномочий
                        доступа контролируется техническими и физическими средствами защиты персональных данных.</p>
                    <p>5.8. Контроль за исполнением сотрудниками Политики и законодательства Республики Казахстан
                        регулирующего
                        обработку персональных данных возложен на руководителя ТОО «ПЭК Казахстан».</p>
                    <p>5.9. Руководители структурных подразделений ТОО «ПЭК Казахстан» несут персональную
                        ответственность за исполнение
                        требований к защите персональных данных их подчиненными.</p><h4 class="">6. Кому мы передаём
                    ваши персональные
                    данные</h4>
                    <p>6.1. Вы имеете право:</p>
                    <ul>
                        <li>получать информацию об обработке Ваших персональных данных;</li>
                        <li>отозвать ранее данное Вами согласие на обработку персональных данных. При получении отзыва
                            Вашего согласия,
                            ТОО «ПЭК Казахстан» вправе продолжить обработку персональных данных, при наличии иных
                            правовых оснований,
                            предусмотренных законодательством Республики Казахстан. Обращаем внимание, что Вы не можете
                            отозвать свое
                            согласие, если это противоречит законам Республики Казахстан, либо у Вас есть неисполненные
                            обязательства
                            (п.2. ст.8 Законом Республики Казахстан от 21.05.2013 № 94-V «О персональных данных и их
                            защите»);
                        </li>
                        <li>требовать уточнения своих персональных данных, их блокирования или уничтожения, если
                            персональные данные
                            являются неполными, устаревшими, недостоверными, незаконно полученными, не являются
                            необходимыми для
                            заявленной цели обработки, а также требовать прекращения обработки персональных данных, если
                            цель такой
                            обработки уже достигнута.
                        </li>
                    </ul>
                    <p>6.2. Для реализации и защиты своих прав и законных интересов Вы или Ваши представители можете
                        обратиться к ТОО
                        «ПЭК Казахстан» путем направления обращения по адресу:&nbsp; г. Алматы, Жетысуский район, ул.
                        Казыбаева, д. 3,
                        Индекс A20Y6A4 (050050).</p>
                    <p>Запрос также может быть направлен в форме электронного документа и подписан электронной подписью
                        на адрес
                        электронной почты pnd@pecom.ru.</p>
                    <p>6.3. Обращаем внимание, что обращение должно в обязательном порядке содержать описание Ваших
                        требований, а также
                        следующие сведения:</p>
                    <ul>
                        <li>ФИО;</li>
                        <li>номер Вашего документа, удостоверяющего личность, сведения о дате выдачи указанного
                            документа и выдавшем его
                            органе, либо иные сведения, позволяющие однозначно идентифицировать Вас;
                        </li>
                        <li>сведения, подтверждающие Ваше участие в отношениях с ТОО «ПЭК Казахстан» (номер договора,
                            дата заключения
                            договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом
                            подтверждающие
                            факт обработки персональных данных ТОО «ПЭК Казахстан»;&nbsp;
                        </li>
                        <li>подпись.</li>
                    </ul>
                    <p>Если обращение подает Ваш представитель, то в обращении также указываются ФИО представителя и
                        прилагается
                        документ, подтверждающий его полномочия.</p>
                    <p>6.4. ТОО «ПЭК Казахстан» предоставляет ответ в той форме, в которой направлены соответствующие
                        обращение либо
                        запрос, если иное не указано в обращении или запросе.</p><h4 class="">7. Порядок уничтожения
                    персональных
                    данных</h4>
                    <p>7.1. Персональные данные подлежат уничтожению в следующих случаях:</p>
                    <ul>
                        <li>по достижении целей обработки или в случае утраты необходимости в их достижении;</li>
                        <li>при прекращении правоотношений между Вами и ТОО «ПЭК Казахстан», при условии, что нет иных
                            законных
                            оснований для продолжения обработки Ваших персональных данных
                        </li>
                        <li>при выявлении фактов неправомерной обработки персональных данных и/или когда обеспечить их
                            правомерность не
                            представляется возможным;
                        </li>
                        <li>при получении соответствующего предписания от уполномоченного органа по защите прав
                            субъектов персональных
                            данных или вступления в силу решения суда;
                        </li>
                        <li>в случае отзыва Вами согласия и когда законных оснований продолжать такую обработку у ТОО
                            «ПЭК Казахстан» не
                            имеется;
                        </li>
                        <li>при истечении предусмотренного Вашим согласием или установленного законом срока обработки
                            персональных
                            данных;&nbsp;
                        </li>
                        <li>в иных случаях, установленных настоящим Законом и иными нормативными правовыми актами
                            Республики
                            Казахстан.
                        </li>
                    </ul>
                    <p>7.2. Уничтожение персональных данных производится в течение одного рабочего дня с момента
                        обнаружения данных,
                        подлежащих уничтожению или подтверждения факта обработки персональных данных с нарушением
                        законодательства
                        Республики Казахстан.</p><h4 class="">8. Заключительные положения</h4>
                    <p>8.1. Иные обязанности и права ТОО «ПЭК Казахстан» как оператора персональных данных и лица,
                        организующего их
                        обработку по поручению других операторов, определяются законодательством Республики Казахстан в
                        области
                        персональных данных.</p>
                    <p>8.2. Должностные лица и Работники ТОО «ПЭК Казахстан», виновные в нарушении норм, регулирующих
                        обработку и защиту
                        персональных данных, несут материальную, дисциплинарную, административную, гражданско-правовую и
                        уголовную
                        ответственность в соответствии с законодательством Республики Казахстан.</p>
                    <p>8.3. ТОО «ПЭК Казахстан» по своему решению проводит изменение положений настоящей Политики, в том
                        числе их
                        актуализацию по мере необходимости, в том числе при наступлении следующих условий:</p>
                    <ul>
                        <li>при изменении нормативно-правовых актов, регулирующих принципы и (или) процессы обработки
                            персональных
                            данных в ТОО «ПЭК Казахстан»;
                        </li>
                        <li>при создании новых или внесении изменений в существующие процессы обработки персональных
                            данных;
                        </li>
                        <li>по результатам проведения аудитов, пентестов, тестирований на проникновение и подтверждения
                            факта
                            несоответствия систем и/или процессов действующей политике.
                        </li>
                    </ul>
                    <p>8.4. Если иное не предусмотрено Политикой, все вносимые в нее изменения вступают в силу с даты,
                        указанной в
                        Политике.</p>
                    <p>8.5. Во всем ином, что не предусмотрено настоящей Политикой, ТОО «ПЭК Казахстан» руководствуется
                        положениями
                        действующего законодательства Республики Казахстан.</p>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script>
export default {
    name: "index"
}
</script>

<style scoped>

</style>
